import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const StoreInfoList = React.memo(
  ({ storeInfo }) =>
    storeInfo && storeInfo.length ? (
      <S.StoreInfoList>
        {storeInfo.map((value, index) => (
          <S.StoreInfoText
            // eslint-disable-next-line react/no-array-index-key
            key={`store-info-${index}`}
          >
            <S.StoreInfoTextInner>{value}</S.StoreInfoTextInner>
          </S.StoreInfoText>
        ))}
      </S.StoreInfoList>
    ) : null,
  ({ storeInfo: prevStoreInfo }, { storeInfo: nextStoreInfo }) => {
    if (!prevStoreInfo && !nextStoreInfo) {
      return true;
    }
    if (
      (!prevStoreInfo && nextStoreInfo) ||
      (prevStoreInfo && !nextStoreInfo) ||
      prevStoreInfo.length !== nextStoreInfo.length
    ) {
      return false;
    }
    return prevStoreInfo.every((value, i) => value === nextStoreInfo[i]);
  }
);

const { string, arrayOf } = PropTypes;

StoreInfoList.propTypes = {
  storeInfo: arrayOf(string),
};

StoreInfoList.defaultProps = {
  storeInfo: [],
};

export default StoreInfoList;
